import klickartMenuToggle from "src/performant/toggleMenu";

const screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;

if (screenWidth <= 767) {
  window.addEventListener("load", klickartMenuToggle);
}
